import React, { Component } from 'react';
import { isEmpty } from "lodash";

import { normalizeStr } from '../../../utils/generalFuncs';
import Dialog from '../../common/Dialog';
import InputText from '../../common/Form';

class ServiceForm extends Component {
    state = { 
        service_name: this.props.service ? this.props.service.service_name : "",
        errors:{
            service_name: "",
        }
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        this.setState({
            [name]: value
        })
    }
    validate = () => {
        let required = [
            "service_name",
            
        ]
        
        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    
    nameExist = (name, id) => {
        const { SERVICES } = this.props;
        let list = []
        list = Object.values(SERVICES).filter(item =>  ( 
            (normalizeStr(item.service_name) === normalizeStr(name) ) && 
            (item.service_id !== id) 
        ) )
            
        console.log("Item exist",{list});
        return !isEmpty(list)
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            if (this.props.update) {
                data = Object.assign(data, this.props.service)
            }
            data.service_name = this.state.service_name.toUpperCase()
    
            console.log('====================================');
            console.log({data});
            console.log('====================================');
            
            // check if name exist
            if(this.nameExist(data.service_name, data.service_id) ){
                this.props.notif("error",`Ce service existe déjà`)
                return
            }

            if(this.props.update){
                await this.props.updateService(data)
            } else {
                await this.props.newService(data)  
            }

            if(this.props.STATE.services.error){
                console.log('====================================');
                console.log("ERROR", this.props.STATE.services );
                console.log('====================================');
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.services.error}`)
            } else {
                !this.props.update && this.props.notif("success","Le service a été créé avec succès")
                this.props.update && this.props.notif("success","Le service a été modifié avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        return (
            <Dialog
                close={this.props.handleClose}
                // fullScreen
                title={`${this.props.update ? "Modifier le " : "Créer un nouveau"} Service`}
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.services.fetching}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
            >
                <InputText
                    required
                    name="service_name" 
                    id="service_name" 
                    value={this.state.service_name} 
                    label="Nom" 
                    placeholder="Nom du service" 
                    error={this.state.errors.service_name} 
                    onChange={this.handleChange}
                />
                    
            </Dialog>

        );
    }
}

export default ServiceForm;